export default class FileService {
    convertBase64ToFIle(data, filename) {
        if (!data) {
            return;
        }

        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const baseStr = atob(arr[1]);
        let n = baseStr.length;
        const u8arr = new Uint8Array(n);
        while (n) {
            u8arr[n - 1] = baseStr.charCodeAt(n - 1);
            n -= 1;
        }

        return new File([u8arr], filename, { type: mime });
    }
}
